/*
 * @file    toast.css
 * @author  Kevin Yu <kevin@distributive.network>
 * @date    July 2024
 */

.toast-primitive-viewport {
  position: fixed;
  bottom: 1em;
  z-index: 100;
  display: flex;
  list-style: none;
  max-width: 420px;
  flex-direction: column;
  width: fit-content;
  min-width: 300px;
  top: auto;
  left: 1em;
  padding: 0;
}

.toast-default {
  color: white;
  padding: 1rem;
  border: 1px solid #3a3a3ae5;
  box-shadow:
    rgb(0 0 0 / 0%) 0 0 0 0,
    rgb(0 0 0 / 0%) 0 0 0 0,
    rgb(0 0 0 / 10%) 0 10px 15px -3px,
    rgb(0 0 0 / 10%) 0 4px 6px -4px;
  background-color: #3a3a3ae5;

  &:focus-visible {
    outline:          2px solid var(--primary-hue-lighter);
    outline-offset:   2px;
    border-radius:    0.5px;
  }
}

.toast-primitive-actions {
  display: inline-flex;
  height: 2rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border-width: 1px;
  background-color: transparent;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
}

.toast-primitive-actions:hover {
  background-color: hsl(210, 40%, 96.1%);
}

.toast-primitive-actions:focus {
  outline: none;
  box-shadow: 0 0 0 1px hsl(222.2 84% 4.9%);
}

.toast-primitive-actions:disabled {
  pointer-events: none;
  opacity: 0.5;
}

.toast-primitive-close {
  position: absolute;
  right: 0.25rem;
  top: 0.25rem;
  border-radius: 0.375rem;
  padding: 0.25rem;
  color: rgb(248 250 252 / 50%);
  opacity: 0.6;
  transition: opacity linear 0.2s;

  &:focus-visible {
    outline: solid 2px white;
    border-radius: 5px;
  }
}

.toast-primitive-close:hover {
  color: rgb(9 9 11);
  opacity: 1;
}

.toast-primitive-close svg {
  color: white;
}

.toast-primitive-close:focus {
  opacity: 1;
  outline: none;
  box-shadow: 0 0 0 1px hsl(210 40% 98%);
}

.toast-content {
  display: grid;
  gap: 5px;
}

.toast-primitive-title {
  font-size: 0.875rem;
  font-weight: 600;
}

.toast-primitive-description {
  font-size: 0.875rem; 
  opacity: 0.9;
}

.toast-default[data-state="closed"] {
  animation: slide-out-to-bottom 0.5s forwards;
}

.toast-default[data-state="open"] {
  animation: slide-in-from-bottom 0.5s forwards;
}

/* Keyframes for animations */
@keyframes slide-out-to-bottom {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(150%);
  }
}

@keyframes slide-in-from-bottom {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.close-toast {
  width: 15px;
  height: 15px;
  filter: brightness(0) saturate(100%) invert(97%) sepia(96%) saturate(1%) hue-rotate(122deg) brightness(104%) contrast(100%);
}